import React from 'react';
import { CheckCircle2, AlertCircle, Wrench, RefreshCw, Info } from 'lucide-react';
export function RepairVsReplace() {
  const repairBullets = ['The chip is small and contained', "The damage is away from the driver's direct line of sight", 'The damage is away from the windshield edge', 'The damage has not spread into a crack', 'Dirt and moisture have not contaminated the damaged area'];
  const replaceBullets = ['The windshield has a crack', 'Damage is spreading', "Damage blocks or distorts the driver's view", 'Damage is near the windshield edge', 'Multiple chips or cracks are present', 'ADAS cameras or sensors may be affected'];
  return <section className="py-16 md:py-20 px-4 sm:px-6 lg:px-8 bg-slate-50 border-y border-slate-200" data-id="element-987">
      <div className="max-w-5xl mx-auto" data-id="element-988">
        <div className="text-center mb-12" data-id="element-989">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-slate-900 mb-4 tracking-tight leading-tight" data-id="element-990">
            Can{' '}
            <span className="text-emergencyBrand-red" data-id="element-991">
              Emergency Windshield Damage
            </span>{' '}
            Be Repaired?
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-992">
          {/* Repair Card */}
          <div className="bg-white rounded-xl p-6 sm:p-8 border border-slate-200 shadow-sm" data-id="element-993">
            <div className="flex items-center gap-3 mb-6" data-id="element-994">
              <div className="bg-emerald-50 p-3 rounded-lg" data-id="element-995">
                <Wrench className="w-6 h-6 text-emerald-600" data-id="element-996" />
              </div>
              <h3 className="text-xl font-bold text-slate-900" data-id="element-997">
                Repair may be possible when…
              </h3>
            </div>
            <ul className="space-y-3.5" data-id="element-998">
              {repairBullets.map((bullet, i) => <li key={i} className="flex items-start gap-3" data-id="element-999">
                  <CheckCircle2 className="w-5 h-5 text-emerald-500 shrink-0 mt-0.5" data-id="element-1000" />
                  <span className="text-slate-700" data-id="element-1001">{bullet}</span>
                </li>)}
            </ul>
          </div>
          {/* Replace Card */}
          <div className="bg-white rounded-xl p-6 sm:p-8 border border-slate-200 shadow-sm" data-id="element-1002">
            <div className="flex items-center gap-3 mb-6" data-id="element-1003">
              <div className="bg-emergencyBrand-redLight p-3 rounded-lg" data-id="element-1004">
                <RefreshCw className="w-6 h-6 text-emergencyBrand-red" data-id="element-1005" />
              </div>
              <h3 className="text-xl font-bold text-slate-900" data-id="element-1006">
                Replacement is usually safer when…
              </h3>
            </div>
            <ul className="space-y-3.5" data-id="element-1007">
              {replaceBullets.map((bullet, i) => <li key={i} className="flex items-start gap-3" data-id="element-1008">
                  <AlertCircle className="w-5 h-5 text-emergencyBrand-red shrink-0 mt-0.5" data-id="element-1009" />
                  <span className="text-slate-700" data-id="element-1010">{bullet}</span>
                </li>)}
            </ul>
          </div>
        </div>
        <div className="bg-white border border-slate-200 rounded-lg p-4 flex gap-3 mb-10 max-w-3xl mx-auto" data-id="element-1011">
          <Info className="w-5 h-5 text-slate-500 shrink-0 mt-0.5" data-id="element-1012" />
          <p className="text-sm text-slate-600 leading-relaxed" data-id="element-1013">
            A windshield chip repair is designed to help stop damage from
            spreading. It may still be visible after repair. Cracks are
            generally not repairable and usually require replacement.
          </p>
        </div>
        <div className="text-center" data-id="element-1014">
          <a href="#quote-form" className="inline-flex items-center justify-center gap-2 bg-emergencyBrand-red hover:bg-emergencyBrand-redHover text-white px-7 py-4 rounded-lg font-bold text-base transition-colors shadow-sm" data-id="element-1015">
            Request a Windshield Inspection
          </a>
        </div>
      </div>
    </section>;
}